/** @format */

import { createAsyncThunk } from "@reduxjs/toolkit";
import { alertMsg } from "../utilities/helper";
import { deleteReq, getReq, postReq, putPostReq, putReq } from "./APIMethods";

export const getClientOrders = createAsyncThunk(
  "clients/getClientsOrder",
  async (obj, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    try {
      const response = await getReq(obj);
      return response.data;
    } catch (err) {
      alertMsg("فشل تحميل البيانات  ", false);
      return rejectWithValue(err);
    }
  }
);

export const getAllClients = createAsyncThunk(
  "clients/getAllClients",
  async (obj, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    try {
      const response = await getReq(obj);
      return response.data;
    } catch (err) {
      alertMsg("فشل تحميل البيانات  ", false);
      return rejectWithValue(err);
    }
  }
);
export const getClient = createAsyncThunk(
  "clients/getClient",
  async (obj, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    try {
      const response = await getReq(obj);

      return response.data;
    } catch (err) {
      alertMsg("فشل تحميل البيانات  ", false);
      return rejectWithValue(err);
    }
  }
);
export const deleteClient = createAsyncThunk(
  "clients/deleteClient",
  async (obj, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    try {
      const response = await deleteReq(obj);
      alertMsg("تم الحذف بنجاح  ", true);

      return response.data;
    } catch (err) {
      alertMsg("فشل تحميل البيانات  ", false);
      return rejectWithValue(err);
    }
  }
);
export const updateClient = createAsyncThunk(
  "clients/updateClient",
  async (obj, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    try {
      const response = await putReq(obj.url, obj.data, obj.file);
      alertMsg("تم التعديل بنجاح  ", true);

      return response.data;
    } catch (err) {
      alertMsg("فشل تعديل البيانات  ", false);
      return rejectWithValue(err);
    }
  }
);
export const addClient = createAsyncThunk(
  "clients/updateClient",
  async (obj, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    try {
      const response = await postReq(obj.url, obj.data, obj.file);
      alertMsg("تم الاضافة بنجاح  ", true);

      return response.data;
    } catch (err) {
      alertMsg("فشل اضافة البيانات  ", false);
      return rejectWithValue(err);
    }
  }
);
export const baneClient = createAsyncThunk(
  "clients/baneClient",
  async (obj, thunkApi) => {
    const { rejectWithValue } = thunkApi;
    try {
      const response = await getReq(obj);
      alertMsg("تم حظر الكفيل بنجاح  ", true);

      return response.data;
    } catch (err) {
      alertMsg("فشل حظر الكفيل   ", false);
      return rejectWithValue(err);
    }
  }
);
